import { getUnixTimestamp } from "../../utils";
import { IPetCreateRequest } from "./pet-create.interface";
import { PetFormType } from "./pet-create.schema";

// export const mapToPetCreateRequest = (
//   newPetOneForm: PetOneFormType,
//   newPetTwoForm: PetTwoFormType,
// ): IPetCreateRequest =>{
//   let birthdateGMT0 = null;

//   if (!!+newPetTwoForm?.knowBirthday && newPetTwoForm.birthdate) {
//     birthdateGMT0 = getUnixTimestamp(new Date(newPetTwoForm.birthdate));
//   } else {
//     birthdateGMT0 = "";
//   }

//   return {
//     name: newPetOneForm.name?.replace(/\s+/g, " "),
//     species: newPetOneForm.species,
//     breed: newPetOneForm.breed ? newPetOneForm.breed : null,
//     birthdate: `${birthdateGMT0}`,
//     gender: `${newPetOneForm.gender}`,
//     isDesexed: newPetOneForm.isDesexed === "1" ? true : false,
//     idColor: newPetOneForm.idColor || null,
//     medicalRecord: newPetOneForm.anyMedicalRecord === "1" ? {
//       city: newPetOneForm.medicalRecordCity as string,
//       clinicName: newPetOneForm.medicalRecordName as string,
//     } : null,
//   };
// };


export const mapToPetCreateRequest2 = (
  newPetOneForm: PetFormType,
): IPetCreateRequest => {
  let birthdateGMT0: string|null;

  if (newPetOneForm.birthdate) {
    birthdateGMT0 = getUnixTimestamp(newPetOneForm.birthdate).toString();
  } else {
    birthdateGMT0 = null;
  }

  return {
    name: newPetOneForm.name?.replace(/\s+/g, " ") || "",
    species: newPetOneForm.species,
    breed: newPetOneForm.breed || null,
    birthdate: birthdateGMT0 || "",
    gender: newPetOneForm.gender || "",
    isDesexed: newPetOneForm.isDesexed === "1",
    idColor: null,
    medicalRecord: newPetOneForm.anyMedicalRecord ? {
      city: newPetOneForm.medicalRecordCity as string,
      clinicName: newPetOneForm.medicalRecordName as string,
    } : null,
  };
};


